export default "__VITE_ASSET__Bm8HudOU__"